import type { ServerMessage } from "../../i18n/serverMessages"

export class ErrorResponse {
  statusCode: number
  messages: Error[]

  constructor(
    statusCode: number,
    messages: Error[]
  ) {
    this.statusCode = statusCode
    this.messages = messages
  }

  static isErrorResponse(obj: any): obj is ErrorResponse {
    return obj !== null && obj.statusCode !== undefined && obj.messages !== undefined
  }
}

export class Error {
  description: string
  code: number
  field?: string
  message?: ServerMessage | null

  constructor(code: number, description: string, field?: string) {
    this.code = code
    this.field = field
    this.description = description
  }
}

export interface ActionResponse<T> {
  success: boolean
  data: T | null
  errors?: Error[]
}